import { IPageStructure } from "api/interfaces/get-page-details/common/nested-pagecontent.type";
import HorizontalSeparator from "component/design-system/horizontal-separator/HorizontalSeparator";
import PAText from "component/design-system/typography/PAText/PAText";
import OverViewTab from "container/manufacturer/OverViewTab";
import HideIf from "util/HideIf";

interface IProps {
  pageStructure: IPageStructure[];
  title?: string;
}

function PageStructureData(props: IProps) {
  const { pageStructure, title, hideHr = false } = props;
  const articles = pageStructure?.filter((item) => item.type === "article");

  if (!pageStructure?.length || !articles?.length) {
    return null;
  }

  return (
    <>
      <HideIf show={title}>
        <PAText
          component="h2"
          className="product_common_title"
          inlineBlock
          bold
        >
          {title}
        </PAText>
      </HideIf>

      <OverViewTab
        items={[pageStructure[0]]}
      />
      <HideIf show={!hideHr}>
        <HorizontalSeparator />
      </HideIf>
    </>
  );
}

export default PageStructureData;
